/* Evita cobrar regalos: solo toca líneas marcadas como regalo (_regalo). Si ya no llega al mínimo de kits, las quita. Nunca añade nada. */
(function () {
  var cfg = window.mtRegalos;
  if (!cfg || window.mtRegalosListo) return;
  window.mtRegalosListo = true;
  function revisar() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var kits = 0;
      c.items.forEach(function (i) { if (i.product_id === cfg.kit) kits += i.quantity; });
      var cambios = {}, hay = false;
      cfg.regalos.forEach(function (g) {
        var linea = c.items.filter(function (i) { return i.variant_id === g.v && i.properties && i.properties._regalo; })[0];
        if (!linea) return;
        var maximo = kits >= g.desde ? 1 : 0;
        if (linea.quantity > maximo) { cambios[linea.key] = maximo; hay = true; }
      });
      if (!hay) return;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: cambios }) })
        .then(function () { window.location.reload(); });
    }).catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', function () {
    revisar();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, revisar);
  });
})();
